export default "__VITE_ASSET__a184e2d2__"